import { createRouter, createWebHistory } from "vue-router";
import store from '../stores';
const SigneUpForm = () =>
  import("../components/registration/step1/SigneUpForm.vue");
const Wecome = () => import("../components/Wecome.vue");
const SignIn = () => import("../components/SingIn/SingIn.vue");
const ForgetPassword = () => import("../components/SingIn/ForgetPassword.vue");
//const Test = () => import("../components/test.vue");
const Dashboard = () => import("../components/participant/Dashboard");
const RegisterForm = () =>
  import("../components/registration/registerform/RegistrationForm.vue");
const Admin = () => import("../components/admin/Admin");
const NewRegistor = () => import("../components/admin/NewRegistor");
const TrainingGroup = () => import("../components/admin/TrainingGroup/TrainingGroup");
const TrainingForm = () => import("../components/admin/TrainingGroup/TrainingForm");
const TrainingParticipant = () => import("../components/admin/TrainingGroup/TrainingParticipant");
const ApprovePerson = () => import("../components/admin/ApprovePerson");
const AlertExpiration = () => import("../components/admin/AlertExpiration/AlertExpiration.vue");
const ShowParticipant = () => import("../components/admin/Participant/ShowParticipant");
const InvoiceManagement = () => import("../components/admin/Invoice/InvoiceManagement");
const ContinueRegisterForm = () =>
  import("../components/registration/registerform/ContinueRegister.vue");
const AbaPaymentForm = () =>
  import("../components/registration/registerform/abaPayment.vue");
const AcledaPaymentForm = () =>
  import("../components/registration/registerform/acledaPayment.vue");
const PaymentSuccess = () =>
  import("../components/registration/registerform/PaymentSuccess.vue");
const PaymentFailed = () =>
  import("../components/registration/registerform/PaymentFailed.vue");
const ShoppingCard = () =>
  import("../components/participant/Shopcard.vue");
const MyRegistration = () =>
  import("../components/participant/MyRegistration.vue");
const MyMember = () =>
  import("../components/participant/MyMemeber.vue");
const PaymentHistory = () =>
  import("../components/participant/PaymentHistory.vue");
const PrintInvoice = () => import("../components/participant/PrintInvoice.vue");
const ChangePassword = () => import("../components/participant/ChangePassword.vue");
const ShowMember = () => import("../components/participant/ShowMember.vue");
const PersonalInfo = () => import("../components/admin/PersonalInfo.vue");
const Personal = () => import("../components/participant/Personal.vue");

const Layout = () => import("../components/ViewLayout.vue");

const routes = [
  // {
  //   path: "/",
  //   name: "Home",
  //   component: Wecome,
  //   meta: {
  //     requiresAuth: false
  //   }
  // },

  {
    path: '/',
    component: Layout,
    children: [
      {
        path: "/",
        name: "Home",
        component: Wecome,
        meta: {
          requiresAuth: false
        }
      }
    ],
  },
  {
    path: "/successlogin",
    name: "successlogin",
    component: () => import("@/components/SuccessLogin.vue"),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/errorlogin",
    name: "errorlogin",
    component: () => import("@/components/ErrorLogin.vue"),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/complete-confirmation",
    name: "competedConfirmation",
    component: () => import("@/components/SigneUpConfirmForm.vue"),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/sing-up",
    name: "SingUp",
    component: SigneUpForm,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/forget-password",
    name: "ForgetPassword",
    component: ForgetPassword
  },
  {
    path: "/system-login",
    name: "SystemLogin",
    component: SignIn,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/register",
    name: "register",
    component: RegisterForm,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/show-register/:id",
    name: "ShowRegister",
    component: RegisterForm,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/continue-register",
    name: "continueRegister",
    component: ContinueRegisterForm,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/aba-payment",
    name: "abaPayment",
    component: AbaPaymentForm,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/acleda-payment",
    name: "acledaPayment",
    component: AcledaPaymentForm,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/payment-success/:transactionId?",
    name: "paymentSuccess",
    component: PaymentSuccess,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/payment-failed/:transactionId?",
    name: "paymentFailed",
    component: PaymentFailed,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/print-invoice/:transactionId",
    name: "printInvoice",
    component: PrintInvoice,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    children:[
      {
        path: '',
        component: MyRegistration,
        name: "myRegistration",
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'my-member',
        component: MyMember,
        name: "myMember",
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'shopping-card',
        component: ShoppingCard,
        name: "shoppingCard",
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'payment-history',
        component: PaymentHistory,
        name: "paymentHistory",
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'change-password',
        component: ChangePassword,
        name: "changePassword",
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'show-member/:memberId',
        component: ShowMember,
        name: "showMember",
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'personal',
        component: Personal,
        name: "personal",
        meta: {
          requiresAuth: true
        }
      }
    ]
  },{
    path: "/admin",
    name: "Admin",
    component: Admin,
    children: [
      {
        path: 'new-registor',
        component: NewRegistor,
        name: "adminNewRegistor",
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'training-group',
        component: TrainingGroup,
        name: "adminTrainingGroup",
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'training-group/create',
        component: TrainingForm,
        name: "createAdminTrainingGroup",
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'training-group/show/:id',
        component: TrainingForm,
        name: "showAdminTrainingGroup",
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'training-group/:id/participant',
        component: TrainingParticipant,
        name: "participantAdminTrainingGroup",
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'approved-person',
        component: ApprovePerson,
        name: "approvePerson",
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'alert-expiration',
        component: AlertExpiration,
        name: "alertExpiration",
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'show-register-participant/:id',
        component: ShowParticipant,
        name: "showParticipant",
        meta: {
          requiresAuth: true
        }
      }
      ,{
        path: 'change-password',
        component: ChangePassword,
        name: "adminChangePassword",
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'personal-information',
        component: PersonalInfo,
        name: "personalInfo",
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'invoice-management',
        component: InvoiceManagement,
        name: "invoiceManagement",
        meta: {
          requiresAuth: true
        }
      },
    ]
  }
];
const router = createRouter({
  history: createWebHistory(),
  mode: "history",
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.getAuthToken) {
      store.dispatch('act_logoutAuth');
      next({ name: 'SystemLogin' });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
